export default {
  name: 'Gallery section - 3',
  tab: 'gallery',
  type: 'media-gallery-default-section',
  content: {
    title: '',
    introtext: '',
    images:
      '[{"item-title":"","item-image":"/storage/media/samples/pexels-marcos-bais-1843572.jpg","button-text":"","button-link":"","button-style":"outlined","button-background-color":"var(--background-color)","button-text-color":"var(--text-light-color)"},{"item-title":"","item-image":"/storage/media/samples/pexels-matheus-natan-1850269.jpg","button-text":"","button-link":"","button-style":"outlined","button-background-color":"var(--background-color)","button-text-color":"var(--text-light-color)"},{"item-title":"","item-image":"/storage/media/samples/pexels-gdtography-911758.jpg","button-text":"","button-link":"","button-style":"outlined","button-background-color":"var(--background-color)","button-text-color":"var(--text-light-color)"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '0px',
    'padding-bottom': '0px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'introtext-color': 'inherit',
    'item-title-color': 'var(--text-light-color)',
    'item-title-font-weight': 'lighter',
    'item-title-tag': 'h6'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'start',
    'content-no-gutters': '0',
    'item-columns': '3',
    'inner-content-horizontal-alignment': 'center',
    'inner-content-padding': '12px',
    'item-size': 'aspect-ratio',
    'item-aspect-ratio': '1.78',
    'content-box': '0',
    'content-box-wrap': 'item',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '0'
  },
  advanced: {}
}
